import { cn } from 'app/javascript/lib/utils';

// Segmented bar of training photos by processing status. Failures are the only
// segment that carries alarm colour; the rest is neutral, because "40 photos
// processed" is not news.
const SEGMENTS: { key: string; label: string; bar: string; dot: string }[] = [
  { key: 'confirmed', label: 'confirmadas', bar: 'bg-primary', dot: 'bg-primary' },
  { key: 'completed', label: 'processadas', bar: 'bg-primary/45', dot: 'bg-primary/45' },
  { key: 'processing', label: 'processando', bar: 'bg-muted-foreground/40', dot: 'bg-muted-foreground/40' },
  { key: 'failed', label: 'falhas', bar: 'bg-destructive', dot: 'bg-destructive' },
];

export default function PhotoStatusBar({ counts }: { counts: Record<string, number> }) {
  const total = Object.values(counts).reduce((sum, count) => sum + count, 0);
  if (total === 0) return null;

  const present = SEGMENTS.filter((segment) => (counts[segment.key] ?? 0) > 0);

  return (
    <div className="space-y-2 py-1.5">
      <div className="flex h-2 overflow-hidden rounded-full bg-secondary">
        {present.map((segment) => (
          <div
            key={segment.key}
            className={cn('h-full', segment.bar)}
            style={{ width: `${((counts[segment.key] ?? 0) / total) * 100}%` }}
          />
        ))}
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1">
        {present.map((segment) => (
          <span key={segment.key} className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
            <span className={cn('size-1.5 rounded-full', segment.dot)} />
            {counts[segment.key]} {segment.label}
          </span>
        ))}
      </div>
    </div>
  );
}
